import React from 'react'
import { connect } from 'react-redux'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { AuthorisedUser, DealDetail, EntityType } from 'api'
import { getDealTitle } from './utils'
import { isOpenFin } from 'utils'
import { Locale, Translation } from 'locale'
import { WindowActions } from 'epics/windowEpic'
import Ticket from './DealTicket'
import { ActionsButtonProps } from 'view/components/datagrid'

import { createStructuredSelector } from 'reselect'
import { authorisedUserSelector } from 'selectors/connectionSelectors'

export type DealActionsButtonProps = OwnProps & StateProps & DispatchProps

interface OwnProps extends ModalConsumerProps, ActionsButtonProps<DealDetail> {
  disabled?: boolean
}

interface StateProps {
  authorisedUser: AuthorisedUser
}

interface DispatchProps {
  onOpenTicket: (entityId: string, entityType: EntityType, windowTitle: string) => unknown
}

const mapStateToProps = createStructuredSelector({
  authorisedUser: authorisedUserSelector
})

const mapDispatchToProps = {
  onOpenTicket: WindowActions.openTicketWindow
}

export const OpenTicketActionsButtonComponent: React.FC<DealActionsButtonProps> = ({
  disabled,
  items,
  isGroupRow,
  showModal,
  onOpenTicket
}) => {
  const getLabel = (baseLabel: Translation) => {
    const count = isGroupRow ? ` (${items.length})` : ``
    return `${Locale.translate(baseLabel)}${count}`
  }

  const handleOpenTicket = () => {
    items.forEach(dealDetail => {
      if (isOpenFin()) {
        onOpenTicket(dealDetail.deal.dealId, EntityType.DEAL, getDealTitle(dealDetail))
      } else {
        showModal(<Ticket dealId={dealDetail.deal.dealId} dealVersion={dealDetail.deal.version} />)
      }
    })
  }

  const actions: ActionItem[] = [
    {
      label: getLabel(Translation.TC_ACTION_OPEN_TICKET),
      onClick: handleOpenTicket,
      enabled: true
    }
  ]

  return <SplitButtonDropdown dataTestId={'DealActionsButton'} actions={actions} disabled={disabled} maxButtons={1} />
}

export const OpenTicketActionsButton = withModal(
  connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(OpenTicketActionsButtonComponent)
)
